import { render, staticRenderFns } from "./__event.vue?vue&type=template&id=6da8aae5&scoped=true&"
import script from "./__event.vue?vue&type=script&lang=js&"
export * from "./__event.vue?vue&type=script&lang=js&"
import style0 from "./__event.vue?vue&type=style&index=0&id=6da8aae5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da8aae5",
  null
  
)

export default component.exports